$(window).load(function(){

  var experience = {
    'name': 'experience',
    'children': []
  };

  var treemap = d3.layout.treemap()
      .sort(function(a, b){
        return +b.size - +a.size;
      })
      .sticky(true)
      .padding(0)
      .value(function(d) { return +d.size; });

  var experienceDiv = d3.select('main')
      .attr('class', 'experience-layout');

  d3.json('/experience.json', initialize);

  // structure the data and initialize the treemap layout
  function initialize( response ) {

    response.data.forEach(function(d, i) {

      var blockName = 'block-' + i;

      return experience.children.push(
        {
          'name': blockName,
          'children': [
            d
          ]
        }
      );

    });

    treemapLayout(experience);

    return null;

  }

  // Draw treemap layout
  function treemapLayout(data) {

    width = document.body.clientWidth;
    multiplier = width > 1000 ? 3: 5;
    height = width * multiplier;
    offset = $('.site-nav').outerHeight() - 1;

    treemap.size([width, height]);

    var t = d3.transition().duration(250);

    experienceDiv.style('width', width + 'px')
      .style('height', height + 'px')
      .style('top', offset + 'px');

    var nodes = experienceDiv.selectAll('.node')
      .data(treemap.nodes( data ), function(d){ return d.name; });

    nodes.exit()
      .remove();

    nodes.transition(t)
      .style('left', function(d) { return d.x + 'px'; })
      .style('top', function(d) { return d.y + 'px'; })
      .style('width', function(d) { return Math.max(0, d.dx + 1) + 'px'; })
      .style('height', function(d) { return Math.max(0, d.dy + 1) + 'px'; });

    nodes.enter()
      .append('a')
      .attr('class', 'node')
      .attr('href', function(d) { return d.url ? d.url : null; })
      .style('left', function(d) { return d.x + 'px'; })
      .style('top', function(d) { return d.y + 'px'; })
      .style('width', function(d) { return Math.max(0, d.dx + 1) + 'px'; })
      .style('height', function(d) { return Math.max(0, d.dy + 1) + 'px'; })
      .style('background', function(d) {
        if ( !d.background ) {
          return null;
        }
        else if ( d.background.charAt(0) == '#') {
          return d.background;
        } else {
          return 'url("' + d.background + '") center center/cover no-repeat #000';
        }
      })
      .html(function(d) { return d.children ? null : d.content; })
      .transition(t);

    return null;

  }

    var resizeTimer;

  // on resize, redraw layout when done resizing
  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      treemapLayout(experience);

    }, 250);

    return null;

  });

});
